// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1MNIH","consentsList":"PatientConsents_consentsList__1Rxy9","consentsListEmpty":"PatientConsents_consentsListEmpty__2cFgR"};